import { sendAnalyticsEventCloseModal, sendAnalyticsEventOpenModal } from "@ui/components/dialog/dialog-analytics";
import { TutorialDialog, VideoTutorialDialogProps } from "@ui/components/tutorial/tutorial-dialog";
import { AnnouncementDialog, AnnouncementDialogProps } from "@ui/pages/announcement-dialog/dialog/announcement-dialog";
import { AboutPhysiomeDialog, AboutPhysiomeDialogProps } from "@ui/pages/home/components/about-physiome-dialog";
import {
	CancelPatientInvitationDialog,
	CancelPatientInvitationDialogProps,
} from "@ui/pages/home/components/cancel-patient-invitation-dialog";
import { AddSurveyDialog, AddSurveyDialogProps } from "@ui/pages/home/components/survey/add-survey-dialog";
import {
	HealthcareTeamAcceptDialog,
	HealthcareTeamAcceptDialogProps,
} from "@ui/pages/home/dialog/healthcare-team-accept-dialog";
import { AddPatientDialog, AddPatientDialogProps } from "@ui/pages/home/pending-patient-dialog/add-patient-dialog";
import {
	MarkAllNotificationsAsReadDialog,
	MarkAllNotificationsAsReadDialogProps,
} from "@ui/pages/notification-center/dialogs/mark-all-notifications-as-read-dialog";
import {
	EditPatientInfoDialog,
	EditPatientInfoDialogProps,
} from "@ui/pages/patient-details/components/dialog/edit-patient-info-dialog";
import {
	HealthcareTeamInviteDialog,
	HealthcareTeamInviteDialogProps,
} from "@ui/pages/patient-details/components/healthcare-team-tab/dialog/healthcare-team-invite-dialog";
import {
	HealthcareTeamLeaveDialog,
	HealthcareTeamLeaveDialogProps,
} from "@ui/pages/patient-details/components/healthcare-team-tab/dialog/healthcare-team-leave-dialog";
import {
	InviteUnregisteredPtDialog,
	InviteUnregisteredPtDialogProps,
} from "@ui/pages/patient-details/components/healthcare-team-tab/dialog/steps/healthcare-team-invite-unregistered-pt-step";
import {
	DuplicateAsTemplateDialog,
	DuplicateAsTemplateDialogProps,
} from "@ui/pages/patient-details/components/program-tab/duplicate-as-template-dialog";
import {
	TemplateListingDialog,
	TemplateListingDialogProps,
} from "@ui/pages/patient-details/components/program-tab/template-listing-dialog";
import {
	ExertionDetailsDialog,
	ExertionDetailsDialogProps,
} from "@ui/pages/patient-details/components/progress-tab/exertion-details-dialog";
import {
	MoodDetailsDialog,
	MoodDetailsDialogProps,
} from "@ui/pages/patient-details/components/progress-tab/mood-details-dialog";
import {
	MobileAlternativeExerciseDialog,
	MobileAlternativeExerciseDialogProps,
} from "@ui/pages/program-builder/alternative-exercise/mobile-alternative-exercise-dialog";
import { DeleteProgramDialog, DeleteProgramDialogProps } from "@ui/pages/program-builder/dialog/delete-program-dialog";
import {
	DuplicateDayColumnDialog,
	DuplicateDayColumnDialogProps,
} from "@ui/pages/program-builder/dialog/duplicate-day-column-dialog";
import {
	ExerciseDetailsDialog,
	ExerciseDetailsDialogProps,
} from "@ui/pages/program-builder/dialog/exercise-details-dialog";
import { RenameProgramDialog, RenameProgramDialogProps } from "@ui/pages/program-builder/dialog/rename-program-dialog";
import { SaveChangesDialog, SaveChangesDialogProps } from "@ui/pages/program-builder/dialog/save-changes-dialog";
import {
	ScheduleProgramDialog,
	ScheduleProgramDialogProps,
} from "@ui/pages/program-builder/dialog/schedule-dialog/schedule-program-dialog";
import {
	StartProgramDialog,
	StartProgramDialogProps,
} from "@ui/pages/program-builder/dialog/schedule-dialog/start-program-dialog";
import { StopProgramDialog, StopProgramDialogProps } from "@ui/pages/program-builder/dialog/stop-program-dialog";
import {
	ConfirmDuplicationDialog,
	ConfirmDuplicationDialogProps,
} from "@ui/pages/program-builder/header/components/confirm-duplication-dialog";
import {
	ProgramBuilderActionsDialog,
	ProgramBuilderActionsDialogProps,
} from "@ui/pages/program-builder/header/components/program-builder-actions-dialog";
import {
	MobileExerciseLibraryDialog,
	MobileExerciseLibraryDialogProps,
} from "@ui/pages/program-builder/mobile/dialog/mobile-exercise-library-dialog";
import { EditPasswordDialog, EditPasswordDialogProps } from "@ui/pages/settings/dialogs/edit-password-dialog";
import {
	EditProfessionalInformationDialog,
	EditProfessionalInformationDialogProps,
} from "@ui/pages/settings/dialogs/edit-professional-information-dialog";
import { AssignTemplateDialog, AssignTemplateDialogProps } from "@ui/pages/program/dialog/assign-template-dialog";
import { DeleteTemplateDialog, DeleteTemplateDialogProps } from "@ui/pages/program/dialog/delete-template-dialog";
import { TemplateNameDialog, TemplateNameDialogProps } from "@ui/pages/program/dialog/template-name-dialog";
import {
	GetStartedCompletedDialog,
	GetStartedCompletedDialogProps,
} from "@ui/pages/get-started-completed-dialog/dialogs/get-started-completed-dialog";
import { ExerciseFiltersDialog, ExerciseFiltersDialogProps } from "@ui/pages/exercise/dialogs/exercise-filters-dialog";
import { DialogProps } from "primereact/dialog";
import React, { createContext, useCallback, useState } from "react";
import { EditUserLocaleDialog, EditUserLocaleDialogProps } from "@ui/pages/settings/dialogs/edit-user-locale-dialog";

export enum ModalId {
	AddPatient = "pendingPatient",
	AddSurvey = "addSurvey",
	ExerciseDetails = "exerciseDetails",
	MobileAlternativeExercise = "mobileAlternativeExercise",
	StartProgram = "startProgram",
	StopProgram = "stopProgram",
	DeleteProgram = "deleteProgram",
	RenameProgram = "renameProgram",
	ScheduleProgram = "scheduleProgram",
	ProgramBuilderActions = "programBuilderActions",
	DuplicateAsTemplateProgram = "duplicateAsTemplateProgram",
	ExertionDetails = "exertionDetails",
	MoodDetails = "moodDetails",
	TemplateName = "templateName",
	DeleteTemplate = "deleteTemplate",
	TemplateListing = "templateListing",
	AssignTemplate = "assignTemplate",
	CancelPatientInvitation = "deletePatient",
	EditPatientInfo = "editPatientInfo",
	AboutPhysiome = "aboutPhysiome",
	HealthcareTeamAccept = "healthcareTeamAccept",
	DuplicateDayColumn = "duplicateDayColumn",
	MarkAllNotificationsAsRead = "markAllNotificationsAsRead",
	EditProfessionalInformation = "editProfessionalInformation",
	EditPassword = "editPassword",
	EditUserLocale = "editSupportedLocale",
	VideoTutorial = "videoTutorial",
	Announcement = "announcement",
	MobileExerciseLibrary = "mobileExerciseLibrary",
	HealthcareTeamInvite = "healthcareTeamInvite",
	HealthcareTeamUnregisteredInvite = "healthcareTeamUnregisteredInvite",
	HealthcareTeamLeave = "healthcareTeamLeave",
	SaveChanges = "saveChanges",
	ConfirmDuplication = "confirmDuplication",
	GetStartedCompleted = "getStartedCompleted",
	ExerciseFilters = "exerciseFilters",
}

type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
type PartialDialogProps<T extends DialogProps> = PartialBy<T, "onHide" | "visible">;

type ModalProps = {
	[ModalId.AddPatient]: PartialDialogProps<AddPatientDialogProps>;
	[ModalId.AddSurvey]: PartialDialogProps<AddSurveyDialogProps>;
	[ModalId.ExerciseDetails]: PartialDialogProps<ExerciseDetailsDialogProps>;
	[ModalId.MobileAlternativeExercise]: PartialDialogProps<MobileAlternativeExerciseDialogProps>;
	[ModalId.StartProgram]: PartialDialogProps<StartProgramDialogProps>;
	[ModalId.StopProgram]: PartialDialogProps<StopProgramDialogProps>;
	[ModalId.DeleteProgram]: PartialDialogProps<DeleteProgramDialogProps>;
	[ModalId.RenameProgram]: PartialDialogProps<RenameProgramDialogProps>;
	[ModalId.ProgramBuilderActions]: PartialDialogProps<ProgramBuilderActionsDialogProps>;
	[ModalId.ScheduleProgram]: PartialDialogProps<ScheduleProgramDialogProps>;
	[ModalId.DuplicateAsTemplateProgram]: PartialDialogProps<DuplicateAsTemplateDialogProps>;
	[ModalId.ExertionDetails]: PartialDialogProps<ExertionDetailsDialogProps>;
	[ModalId.MoodDetails]: PartialDialogProps<MoodDetailsDialogProps>;
	[ModalId.TemplateName]: PartialDialogProps<TemplateNameDialogProps>;
	[ModalId.DeleteTemplate]: PartialDialogProps<DeleteTemplateDialogProps>;
	[ModalId.TemplateListing]: PartialDialogProps<TemplateListingDialogProps>;
	[ModalId.AssignTemplate]: PartialDialogProps<AssignTemplateDialogProps>;
	[ModalId.CancelPatientInvitation]: PartialDialogProps<CancelPatientInvitationDialogProps>;
	[ModalId.EditPatientInfo]: PartialDialogProps<EditPatientInfoDialogProps>;
	[ModalId.AboutPhysiome]: PartialDialogProps<AboutPhysiomeDialogProps>;
	[ModalId.HealthcareTeamAccept]: PartialDialogProps<HealthcareTeamAcceptDialogProps>;
	[ModalId.DuplicateDayColumn]: PartialDialogProps<DuplicateDayColumnDialogProps>;
	[ModalId.MarkAllNotificationsAsRead]: PartialDialogProps<MarkAllNotificationsAsReadDialogProps>;
	[ModalId.EditProfessionalInformation]: PartialDialogProps<EditProfessionalInformationDialogProps>;
	[ModalId.EditPassword]: PartialDialogProps<EditPasswordDialogProps>;
	[ModalId.EditUserLocale]: PartialDialogProps<EditUserLocaleDialogProps>;
	[ModalId.Announcement]: PartialDialogProps<AnnouncementDialogProps>;
	[ModalId.VideoTutorial]: PartialDialogProps<VideoTutorialDialogProps>;
	[ModalId.MobileExerciseLibrary]: PartialDialogProps<MobileExerciseLibraryDialogProps>;
	[ModalId.HealthcareTeamInvite]: PartialDialogProps<HealthcareTeamInviteDialogProps>;
	[ModalId.HealthcareTeamUnregisteredInvite]: PartialDialogProps<InviteUnregisteredPtDialogProps>;
	[ModalId.HealthcareTeamLeave]: PartialDialogProps<HealthcareTeamLeaveDialogProps>;
	[ModalId.SaveChanges]: PartialDialogProps<SaveChangesDialogProps>;
	[ModalId.ConfirmDuplication]: PartialDialogProps<ConfirmDuplicationDialogProps>;
	[ModalId.GetStartedCompleted]: PartialDialogProps<GetStartedCompletedDialogProps>;
	[ModalId.ExerciseFilters]: PartialDialogProps<ExerciseFiltersDialogProps>;
};

type OpenModalProps<T extends ModalId> = keyof ModalProps[T] extends never ? [undefined?] : [ModalProps[T]];

const ModalIdComponents: { [K in ModalId]: React.FC<RequiredProps & ModalProps[K]> } = {
	[ModalId.AddPatient]: AddPatientDialog,
	[ModalId.ExerciseDetails]: ExerciseDetailsDialog,
	[ModalId.MobileAlternativeExercise]: MobileAlternativeExerciseDialog,
	[ModalId.StartProgram]: StartProgramDialog,
	[ModalId.StopProgram]: StopProgramDialog,
	[ModalId.DeleteProgram]: DeleteProgramDialog,
	[ModalId.RenameProgram]: RenameProgramDialog,
	[ModalId.ScheduleProgram]: ScheduleProgramDialog,
	[ModalId.ProgramBuilderActions]: ProgramBuilderActionsDialog,
	[ModalId.DuplicateAsTemplateProgram]: DuplicateAsTemplateDialog,
	[ModalId.ExertionDetails]: ExertionDetailsDialog,
	[ModalId.MoodDetails]: MoodDetailsDialog,
	[ModalId.TemplateName]: TemplateNameDialog,
	[ModalId.DeleteTemplate]: DeleteTemplateDialog,
	[ModalId.TemplateListing]: TemplateListingDialog,
	[ModalId.AssignTemplate]: AssignTemplateDialog,
	[ModalId.CancelPatientInvitation]: CancelPatientInvitationDialog,
	[ModalId.EditPatientInfo]: EditPatientInfoDialog,
	[ModalId.AboutPhysiome]: AboutPhysiomeDialog,
	[ModalId.HealthcareTeamAccept]: HealthcareTeamAcceptDialog,
	[ModalId.DuplicateDayColumn]: DuplicateDayColumnDialog,
	[ModalId.MarkAllNotificationsAsRead]: MarkAllNotificationsAsReadDialog,
	[ModalId.EditProfessionalInformation]: EditProfessionalInformationDialog,
	[ModalId.EditPassword]: EditPasswordDialog,
	[ModalId.EditUserLocale]: EditUserLocaleDialog,
	[ModalId.Announcement]: AnnouncementDialog,
	[ModalId.VideoTutorial]: TutorialDialog,
	[ModalId.MobileExerciseLibrary]: MobileExerciseLibraryDialog,
	[ModalId.HealthcareTeamInvite]: HealthcareTeamInviteDialog,
	[ModalId.HealthcareTeamUnregisteredInvite]: InviteUnregisteredPtDialog,
	[ModalId.HealthcareTeamLeave]: HealthcareTeamLeaveDialog,
	[ModalId.SaveChanges]: SaveChangesDialog,
	[ModalId.ConfirmDuplication]: ConfirmDuplicationDialog,
	[ModalId.AddSurvey]: AddSurveyDialog,
	[ModalId.GetStartedCompleted]: GetStartedCompletedDialog,
	[ModalId.ExerciseFilters]: ExerciseFiltersDialog,
};

interface DialogContextProps {
	openModal: <T extends ModalId>(id: T, ...props: OpenModalProps<T> | [undefined?]) => void;
	closeAll: () => void;
}

export const DialogContext = createContext<DialogContextProps | null>(null);

interface DialogState {
	id: ModalId;
	visible: boolean;
	props: ModalProps[ModalId];
}

const filterVisibleDialogs = (currentStack: DialogState[]) => currentStack.filter(state => state.visible);

export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [dialogStack, setDialogStack] = useState<DialogState[]>([]);

	const scheduleDialogCleanup = useCallback(() => {
		setTimeout(() => {
			setDialogStack(filterVisibleDialogs);
		}, 100);
	}, []);

	const closeDialogStackUpdater = useCallback(
		(id: ModalId) => (currentStack: DialogState[]) => {
			const index = currentStack.findIndex(state => state.id === id);
			if (index === -1) return currentStack;
			const newStack = [...currentStack];
			newStack[index].visible = false;
			sendAnalyticsEventCloseModal(id);
			return newStack;
		},
		[],
	);

	const openModal = useCallback(<T extends ModalId>(id: T, ...props: OpenModalProps<T> | [undefined?]) => {
		setDialogStack(currentStack => {
			const index = currentStack.findIndex(state => state.id === id);
			if (index !== -1) {
				const existing = currentStack[index];
				if (existing.visible) return currentStack;
				const newStack = [...currentStack];
				newStack[index] = { ...existing, visible: true, props: props[0] ?? existing.props };
				sendAnalyticsEventOpenModal(id);
				return newStack;
			}
			sendAnalyticsEventOpenModal(id);
			return [...currentStack, { id, visible: true, props: props[0] ?? {} }];
		});
	}, []);

	const closeModal = useCallback(
		(id: ModalId) => {
			if (dialogStack.length === 0) return;

			setDialogStack(closeDialogStackUpdater(id));
			scheduleDialogCleanup();
		},
		[closeDialogStackUpdater, dialogStack.length, scheduleDialogCleanup],
	);

	const closeAll = useCallback(() => {
		dialogStack.forEach(state => closeModal(state.id));
		setDialogStack([]);
	}, [closeModal, dialogStack]);

	const renderModal = useCallback(
		(state: DialogState) => {
			const { id, props, visible } = state;
			const commonProps: RequiredProps & ModalProps[ModalId] = {
				onHide: () => closeModal(state.id),
				...props,
				visible,
			};
			const ModalIdComponent = ModalIdComponents[id] as React.FC<RequiredProps & ModalProps[ModalId]>;
			return <ModalIdComponent key={state.id} {...commonProps} />;
		},
		[closeModal],
	);

	const contextValue = React.useMemo(() => ({ openModal, closeAll }), [openModal, closeAll]);

	return (
		<DialogContext.Provider value={contextValue}>
			{children}
			{dialogStack.map(renderModal)}
		</DialogContext.Provider>
	);
};

type RequiredProps = Pick<DialogProps, "visible" | "onHide">;
